import dayjs from "dayjs";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export type ReceivedProps = Record<string, any>;

export const DEFAULT_TAB = "salary_list";

const useMaintenanceNotificationList = (props: ReceivedProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentYear = dayjs().format("YYYY");
  const yearParams = searchParams.get("year");
  const [yearTarget, setYearTarget] = useState<string>(
    yearParams || currentYear,
  );

  return {
    ...props,
    activeKey: props?.activeKey,
    setSearchParams,
    yearTarget,
    setYearTarget,
    yearParams,
    currentYear,
  };
};

export type Props = ReturnType<typeof useMaintenanceNotificationList>;

export default useMaintenanceNotificationList;
